import styled from 'styled-components'
import Text from '../../atoms/Text'
import BaseInput from '../../atoms/BaseInput';

const Container = styled.div`
  width: 100%;
`
const LabelWrapper = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 4px;
`
const RequiredCircle = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.status.error};
`
const InputWrapper = styled.div`
  width: 100%;
  position: relative;
`
const Timer = styled(Text)`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
`
const VerificationCodeInput = ({placeholder, value, onChange, required=false, $error, timer, isTimerRunning, ...props}) => {
  return (
    <Container>
      <label>
        <LabelWrapper>
          <Text as="label" variant="body2" weight="medium">인증코드</Text>
          {required && <RequiredCircle aria-label="필수 입력 항목"/>}
        </LabelWrapper>
        <InputWrapper>
          <BaseInput 
            placeholder={placeholder} 
            value={value} 
            onChange={onChange}
            $error={$error}
            {...props}/>
            {isTimerRunning && (
              <Timer variant="body1" color="error">
                {timer}
              </Timer>
            )}
        </InputWrapper>
      </label>
    </Container>
  )
}

export default VerificationCodeInput
